var map = {
	"./IT_Workplan_page-0001.jpg": 1894,
	"./IT_Workplan_page-0002.jpg": 8730,
	"./IT_Workplan_page-0003.jpg": 2493,
	"./IT_Workplan_page-0004.jpg": 5896,
	"./IT_Workplan_page-0005.jpg": 5739,
	"./IT_Workplan_page-0006.jpg": 5941
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6085;